import isPropValid from "@emotion/is-prop-valid";
import { JSX } from "react";
import styled from "styled-components";

export const styledSafe = <T extends keyof JSX.IntrinsicElements>(tag: T) =>
  styled(tag).withConfig({
    shouldForwardProp: (prop) => isPropValid(prop),
  });
